/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ClientBlacklistRequest {
  firstName?: string;
  lastName?: string;
  dateOfBirth: string;
  postCode?: string;
}
